import { copyToClipboard } from '../parts/helpers';
export const copyTriggersInit = () => {
    const containers = document.querySelectorAll('.js-copy-onboard-container');
    containers &&
        containers.forEach((item) => {
            const btn = item.querySelector('button[data-copy]');
            const parent = item;
            btn &&
                btn.addEventListener('click', (btn) => {
                    const { target } = btn;
                    if (target) {
                        copyToClipboard(parent, target);
                    }
                });
        });
};
